import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledHero = styled.div`
  background-image: ${() =>
    `url('${getPublicPath('/images/battleReport/bg-hero.svg')}')`};
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: cover;
  padding: ${spacing('xl4')} ${spacing('md')} 0;
  margin-bottom: ${spacing('xl5')};

  @media (min-width: ${screen('md')}) {
    background-image: ${() =>
      `url('${getPublicPath('/images/battleReport/bg-hero.svg')}')`};
    background-position: left 15% bottom;
    padding: ${spacing('xl4')} ${spacing('xl')} 0;
    background-position: center bottom;
    margin-bottom: ${spacing('xl4')};
    background-size: cover;
  }
`;

export const StyledWrapper = styled.div`
  max-width: ${container('xl')};
  margin: auto;
`;

export const StyledContainer = styled.div`
  color: ${color('text_white')};
  line-height: 1.5;
  text-align: center;

  @media (min-width: ${screen('md')}) {
    display: flex;
    gap: ${spacing('xl3')};
    text-align: left;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    gap: ${spacing('xl6')};
    padding-bottom: ${spacing('xl3')};
  }

  img {
    max-width: 20rem;
    margin-bottom: -${spacing('xl4')};

    @media (min-width: ${screen('md')}) {
      width: 50%;
      margin-bottom: 0;
    }
  }

  > div {
    @media (min-width: ${screen('md')}) {
      max-width: 32rem;
    }
  }
`;
